import styled from 'styled-components';
import { MatchLayoutProps } from './index';

export const MatchesList = styled.div<MatchLayoutProps>`
  display: grid;
  grid-template-columns: repeat(1, minmax(1fr, 1fr));
  grid-gap: 12px;
`;
